import React from "react";
import { SpaceBetweenStack, StyledPagination, StyledTablePagination } from "../StyledComponents/styled";
import { Box, Stack } from "@mui/material";

const NumberedPagination = ({ totalCount, defaultSelectedPage, changeCall, rowSizeChangeCall, rowSize, totalRecordCount }) => {

    const handleChangeRowsPerPage = (event) => {
        // setRowsPerPage(parseInt(event.target.value, 10));
        rowSizeChangeCall(parseInt(event.target.value, 10)); // Call the row size change callback
    };

    return (
        <SpaceBetweenStack
            direction={"row"}
            spacing={2}
            width={"100%"}
            justifyContent={"space-between"}
            display={"flex"}
        >

            {/* ------------- total records info --------------  */}
            <StyledTablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={totalRecordCount}
                page={parseInt(defaultSelectedPage - 1)}
                onPageChange={() => { }} // dummy handler
                rowsPerPage={rowSize}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={() => null} // This hides the prev/next buttons
                labelDisplayedRows={({ from, to, count }) => "Showing " + from + " - " + to + " of " + count} // Optional: hides the range label like "1–5 of 20"
            />
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                position="absolute"
                left="58%"
                sx={{ transform: 'translateX(-50%)' }}
            >
                <Stack direction="row" spacing={2}>
                    {/* ----------- navigation for numbered pagination --------- */}
                    <StyledPagination
                        count={totalCount}
                        onChange={changeCall}
                        variant="text"
                        page={defaultSelectedPage}
                        siblingCount={2}
                    />
                    {/* ----------- rows per page info -------- */}
                    <StyledTablePagination
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        component="div"
                        count={totalRecordCount} // dummy value, won't be used
                        page={defaultSelectedPage - 1} // dummy value, won't be used
                        onPageChange={() => { }} // dummy handler
                        rowsPerPage={rowSize}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={() => null} // This hides the prev/next buttons
                        labelDisplayedRows={() => null} // Optional: hides the range label like "1–5 of 20"
                    />
                </Stack>

            </Box>


        </SpaceBetweenStack>
    );
};

export default NumberedPagination;
